import { useShowMoreToggle } from "@Shared/@Composables/generic/useShowMoreToggle";
import { defineComponent, toRefs } from "@vue/composition-api";
export default defineComponent({
  name: "ShowMore",
  props: {
    text: {
      type: String,
      default: ""
    },
    limit: {
      type: Number,
      default: 25
    },
    tag: {
      type: String,
      default: "p"
    }
  },
  setup(props) {
    const {
      showMore,
      showMoreButtonText,
      showMoreButtonIcon,
      toggleShowMore
    } = useShowMoreToggle();
    const {
      limit,
      text
    } = toRefs(props);
    const truncatedText = text.value.length > limit.value ? `${text.value.substr(0, limit.value)}...` : text.value;
    return {
      truncatedText,
      toggleShowMore,
      showMoreButtonText,
      showMoreButtonIcon,
      showMore
    };
  }
});